import { Component, OnDestroy, OnInit } from "@angular/core";
import { SharedImports } from "../../components/shared.module";
import { BaseLayoutComponent } from "../base-layout.component";

/**
 * This component handles the execution and management of a script environment,
 * specifically interacting with a remote VS Code instance. It provides functionality
 * to launch, monitor, and close the IDE, and to copy credentials to the clipboard.
 * */
@Component({
  selector: "app-script-executor",
  standalone: true,
  imports: [...SharedImports],
  templateUrl: "./script-executor.component.html",
  styleUrl: "./script-executor.component.scss",
})
export class ScriptExecutorComponent
  extends BaseLayoutComponent
  implements OnInit, OnDestroy
{
  message: string = "Copy the key before launch IDE";

  copyText: string = "";
  projectId: any;
  url: string = "";
  loading: boolean = false;
  isDestroyed: boolean = false;
  isLaunchIDE: boolean = false;
  isLoadingIDE: boolean = false;

  /**
   * Copies the `copyText` to the clipboard.
   * Uses the native `document.execCommand` method to copy the text.
   */
  copyToClipboard() {
    const copyInput = document.getElementById("copyInput") as HTMLInputElement;
    if (copyInput) {
      copyInput.select();
      copyInput.setSelectionRange(0, 99999);
      document.execCommand("copy");
    }
  }

  /**
   * Lifecycle hook that is called after the component is initialized.
   * Initializes the project ID, creates an IDE instance, and sets up the loading state.
   */
  ngOnInit(): void {
    this.copyText = "";
    this.projectId = this.dataStore.data.id;
    console.log("On Init");
    this.loading = true;
    this.restService.createInstance(this.projectId).subscribe(
      (item: any) => {
        console.log("Call VS code", item);
        this.copyText = item?.data?.password;
        this.url = item?.data?.url;
        if (!item?.data?.already_have_instance) {
          setTimeout(() => {
            this.loading = false;
          }, 15000);
        } else {
          this.loading = false;
        }
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  /**
   * Opens the VS Code instance in a new browser tab.
   */
  openVsCode() {
    window.open(this.url, "_blank");
  }

  /**
   * Lifecycle hook that is called when the component is destroyed.
   * Logs a message to the console.
   */
  ngOnDestroy(): void {
    console.log("Component Destroyed");
  }

  /**
   * Launches the IDE by creating a new instance.
   * Updates the component states during the process.
   */
  launchIDE() {
    this.isLoadingIDE = true;
    this.restService.createInstance(this.projectId).subscribe(
      (item: any) => {
        console.log("Call VS code", item);
        this.copyText = item?.data?.password;
        this.url = item?.data?.url;
        if (!item?.data?.already_have_instance) {
          setTimeout(() => {
            this.isLoadingIDE = true;
            this.isLaunchIDE = false;
          }, 15000);
        } else {
          this.isLoadingIDE = true;
          this.isLaunchIDE = false;
        }
      },
      (error) => {
        this.isLoadingIDE = true;
        this.isLaunchIDE = false;
      }
    );
  }

  /**
   * Closes the IDE instance and updates component states.
   */
  closeVsCode() {
    this.isDestroyed = true;
    this.restService.deleteInstance(this.projectId).subscribe({
      next: () => {
        this.isDestroyed = false;
        this.isLaunchIDE = true;
      },
      error: (err) => {
        this.isDestroyed = false;
      },
    });
  }
}
